import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/themes/base/datepicker.css'
import 'jquery-timepicker/jquery.timepicker'
import 'jquery-timepicker/jquery.timepicker.css'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import { Slider, SliderItem } from '../components/slider'
import Modal from '../components/modal'
import Highlights from '../components/highlights'
import FormConsulting from '../forms/consulting'
import BlogNewsletter from '../components/blog-newsletter'

export default {
  name: 'Product',
  components: {
    Modal,
    Highlights,
    FormConsulting,
    BlogNewsletter,
    Slider,
    SliderItem,
    VueSlickCarousel,
  },
  data() {
    return {
      openConsulting: false,
      highlight: null,
      subproductId: null,
      clientSliderOptions: {
        arrows: false,
        autoplay: true,
        swipe: false,
        autoplaySpeed: 0,
        slidesToShow: 6,
        speed: 3000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
      testimonialSliderOptions :{
        arrows: true,
        slidesToShow: 1,
        speed: 500,
        cssEase: 'linear'
      }
    }
  },
  mounted() {
    // Set num of
    const currentClientSlides = parseInt(this.$refs.client_slider.dataset.currentClients, 16)

    if (currentClientSlides < 6) {
      this.clientSliderOptions.slidesToShow = currentClientSlides - 1
    } else {
      this.clientSliderOptions.slidesToShow = 6
    }

    /**
     * Force Scroll in to SubProduct
     *
     * This is needed cause Vue takes time to load
     * and the content is not ready when user hit pages
     */
    if (window.location.hash) {
      document.querySelector(window.location.hash).scrollIntoView()
    }

    // Product Slider
    // responsive: {
    //   1024: {
    //     cols: 3,
    //   },
    //   768: {
    //     cols: 3,
    //   },
    //   600: {
    //     cols: 2,
    //   },
    //   475: {
    //     cols: 1,
    //   },
    // },

    $('.calendar').datepicker({ numberOfMonths: 2, firstDay: 1 })
    $('.timepicker').timepicker()

    this.changeSubproduct(this.$refs.initservice.dataset.initservice)
  },
  methods: {
    changeSubproduct(id) {
      this.subproductId = id
    },
  },
}
